import { ApolloLink } from "@apollo/client";
import { getBaggageHeaders } from "@shuttlerock/observability";

/**
 * Injects the current OTEL trace/baggage headers into every outgoing operation.
 *
 * The propagation itself belongs to `@shuttlerock/observability`, which stays
 * transport-agnostic; this is only the Apollo wiring, so it lives beside the
 * other links that make up the client.
 */
export const otelBaggageLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }: { headers?: Record<string, string> }) => ({
    headers: { ...headers, ...getBaggageHeaders() },
  }));

  return forward(operation);
});
